import React from 'react';

function shiftMonth(year, month, delta) {
  const base = (Number(year) * 12) + (Number(month) - 1) + delta;
  return {
    year: Math.floor(base / 12),
    month: (base % 12) + 1,
  };
}

export function MonthNavigator({
  year,
  month,
  onChange,
  onReset,
  resetLabel = '기본월',
  showReset = false,
  disabled = false,
  compact = false,
  style = null,
}) {
  const label = `${Number(year)}년 ${Number(month)}월`;

  function move(delta) {
    if (disabled) return;
    const next = shiftMonth(year, month, delta);
    onChange?.(next);
  }

  return (
    <div style={{ ...styles.wrap, ...(compact ? styles.wrapCompact : null), ...(style || {}) }}>
      <button
        type="button"
        style={{ ...styles.navBtn, ...(disabled ? styles.disabled : null) }}
        onClick={() => move(-1)}
        disabled={disabled}
        aria-label="이전 달"
      >
        ‹
      </button>
      <div style={{ ...styles.label, ...(compact ? styles.labelCompact : null) }}>{label}</div>
      <button
        type="button"
        style={{ ...styles.navBtn, ...(disabled ? styles.disabled : null) }}
        onClick={() => move(1)}
        disabled={disabled}
        aria-label="다음 달"
      >
        ›
      </button>
      {showReset && (
        <button
          type="button"
          style={{ ...styles.resetBtn, ...(disabled ? styles.disabled : null) }}
          onClick={onReset}
          disabled={disabled}
        >
          {resetLabel}
        </button>
      )}
    </div>
  );
}

const styles = {
  wrap: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    minWidth: 0,
  },
  wrapCompact: {
    gap: 4,
  },
  navBtn: {
    width: 34,
    height: 34,
    border: '1px solid var(--border)',
    borderRadius: 8,
    background: 'var(--bg-card)',
    color: 'var(--text)',
    fontSize: 20,
    fontWeight: 900,
    lineHeight: 1,
    cursor: 'pointer',
  },
  label: {
    minWidth: 116,
    height: 34,
    padding: '0 12px',
    border: '1px solid var(--border)',
    borderRadius: 8,
    background: 'var(--bg-subtle)',
    color: 'var(--text)',
    fontSize: 13,
    fontWeight: 950,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
  },
  labelCompact: {
    minWidth: 104,
    padding: '0 10px',
  },
  resetBtn: {
    height: 34,
    border: '1px solid var(--border)',
    borderRadius: 8,
    padding: '0 10px',
    background: 'var(--bg-card)',
    color: 'var(--text-sub)',
    fontSize: 12,
    fontWeight: 850,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  disabled: {
    opacity: 0.55,
    cursor: 'not-allowed',
  },
};

export default MonthNavigator;
